<template>
  <div class="search-form">
    <b-row class="mt-1">
      <b-col cols="6">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.table_spu_search') ||
                  'SPU中英文名称/品牌/系列/品类/SPU编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col
            :span="12"
            v-if="!amzSpuStatusList || !amzSpuStatusList.length"
          >
            <el-form-item
              :label="$l('INDEX.form_label_amzSpuStatus') || '产品状态'"
            >
              <el-checkbox-group v-model="form.listAmzSpuStatus">
                <el-checkbox label="Q">
                  {{ $l('INDEX.form_label_amzSpuStatus_q') || '企划' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_amzSpuStatus_y') || '正式产品' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('INDEX.form_label_amzSpuStatus_d') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_Spuno') || 'SPU编号'">
              <el-input v-model.trim="form.amzSpuNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
            >
              <el-input v-model.trim="form.goodsName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_brand') || '品牌'"
              prop="brandCode"
            >
              <dict-select
                v-model="form.brandCode"
                url="/master/common/dict/spuBrandSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                "
                :selectedLabel.sync="form.brandName"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.replenishment_label_goodsNameEn') || '英文名称'"
            >
              <el-input v-model.trim="form.goodsNameEn" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_succession') || '系列'">
              <dict-select
                v-model="form.collectionNo"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('INDEX.form_label_selectseries') || '请选择系列'
                "
                :body="skuCollectionParams"
                :selectedLabel.sync="form.collectionName"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_category') || '主分类'"
              prop="categoryCode"
            >
              <el-cascader
                :options="categoryTree"
                :props="{
                  emitPath: false,
                  checkStrictly: false,
                  value: 'value',
                  label: 'label',
                }"
                ref="cascaderCategoryTreeRef"
                v-model="form.categoryCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width: 100%"
                :showAllLevels="false"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_design') || '企划人员'"
              prop="designCode"
            >
              <dict-select
                v-model="form.designCode"
                :body="userStatusListParams"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_design') || '请选择企划人员'
                "
                :selectedLabel.sync="form.designName"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_buyer') || '采购人员'"
              prop="buyerCode"
            >
              <dict-select
                v-model="form.buyerCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="form.buyerName"
                :placeholder="
                  $l('INDEX.form_placeholder_buyer') || '请选择采购人员'
                "
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listAmzSpuStatus: ['Q', 'Y'],
}
export default {
  props: {
    amzSpuStatusList: { type: Array, default: () => [] },
    isVcList: { type: Array, default: () => [] },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      skuBrandParams: { dictType: 'skuBrand' },
      skuCollectionParams: { dictType: 'skuCollection' },
      skuCategoryParams: { dictType: 'skuCategory' },
      masterCategoryParams: { parentCode: 'ABSHome' },
      userStatusListParams: { userStatusList: ['Y', 'N', 'S'] },
      categoryTree: [],
    }
  },
  mounted() {
    this.query()
    this.getTreeData()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const status =
        this.amzSpuStatusList && this.amzSpuStatusList.length
          ? this.amzSpuStatusList
          : this.form.listAmzSpuStatus
      this.$emit('query', {
        ...this.form,
        listAmzSpuStatus: status,
        amzSpuStatusList: status,
      })
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    changeType() {
      this.$emit('clearCheck')
      this.reset()
      this.query()
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
